var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 54,
    viewBox: "0 0 75 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2656 3.95703H70.711C71.2561 3.95687 71.7959 4.06422 72.2995 4.27295C72.8032 4.48168 73.2608 4.78769 73.6462 5.17351C74.0317 5.55933 74.3374 6.01739 74.5459 6.52152C74.7545 7.02564 74.8617 7.56596 74.8615 8.11159V49.0284H12.2656V3.95826V3.95703Z",
    fill: "#2E75FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9051 6.04405C15.9035 4.44124 15.2664 2.9046 14.1336 1.7717C13.0009 0.6388 11.4652 0.00227774 9.86394 0.00195312H4.81529C3.59128 0.002096 2.41311 0.468072 1.5196 1.30543C0.626083 2.1428 0.0840709 3.2889 0.00342521 4.51142C-0.00893877 4.70639 0.0122269 4.90204 0.0659978 5.08984L1.39717 9.81177L12.2539 49.6614C12.2657 49.7017 12.2751 49.7427 12.2821 49.7842C12.66 51.7945 14.904 53.6526 17.0511 53.6526H70.6661C71.7193 53.6525 72.734 53.2561 73.5088 52.542C74.2836 51.8279 74.7618 50.8483 74.8486 49.7977C74.8641 49.5845 74.8391 49.3703 74.775 49.1665L64.0704 14.4281C64.0218 14.2781 63.9929 14.1225 63.9845 13.9651C63.9334 12.8458 63.4532 11.7894 62.6438 11.0154C61.8345 10.2414 60.7582 9.8094 59.6389 9.80931H21.0691C18.9932 9.80685 15.9051 8.12195 15.9051 6.04405Z",
    fill: "#8EB5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.e81bb28c1ace31f263f4818c06a6ded1.svg";
export { ForwardRef as ReactComponent };